export default [
  {
    label: '阿富汗',
    labelEn: 'Afghan',
    value: 'Afghan',
    hasChild: false,
    children: [],
    alpha2: 'AF',
    alpha3: 'AFG'
  },
  {
    label: '阿尔巴尼亚',
    labelEn: 'Albanian',
    value: 'Albanian',
    hasChild: false,
    children: [],
    alpha2: 'AL',
    alpha3: 'ALB'
  },
  {
    label: '阿尔及利亚',
    labelEn: 'Algerian',
    value: 'Algerian',
    hasChild: false,
    children: [],
    alpha2: 'DZ',
    alpha3: 'DZA'
  },
  {
    label: '安道尔',
    labelEn: 'Andorran',
    value: 'Andorran',
    hasChild: false,
    children: [],
    alpha2: 'AD',
    alpha3: 'AND'
  },
  {
    label: '安哥拉',
    labelEn: 'Angolan',
    value: 'Angolan',
    hasChild: false,
    children: [],
    alpha2: 'AO',
    alpha3: 'AGO'
  },
  {
    label: '安提瓜和巴布达',
    labelEn: 'Antiguan or Barbudan',
    value: 'Antiguan or Barbudan',
    hasChild: false,
    children: [],
    alpha2: 'AG',
    alpha3: 'ATG'
  },
  {
    label: '阿根廷',
    labelEn: 'Argentine',
    value: 'Argentine',
    hasChild: false,
    children: [],
    alpha2: 'AR',
    alpha3: 'ARG'
  },
  {
    label: '亚美尼亚',
    labelEn: 'Armenian',
    value: 'Armenian',
    hasChild: false,
    children: [],
    alpha2: 'AM',
    alpha3: 'ARM'
  },
  {
    label: '澳大利亚',
    labelEn: 'Australian',
    value: 'Australian',
    hasChild: false,
    children: [],
    alpha2: 'AU',
    alpha3: 'AUS'
  },
  {
    label: '奥地利',
    labelEn: 'Austrian',
    value: 'Austrian',
    hasChild: false,
    children: [],
    alpha2: 'AT',
    alpha3: 'AUT'
  },
  {
    label: '阿塞拜疆',
    labelEn: 'Azerbaijani, Azeri',
    value: 'Azerbaijani, Azeri',
    hasChild: false,
    children: [],
    alpha2: 'AZ',
    alpha3: 'AZE'
  },
  {
    label: '巴哈马群岛',
    labelEn: 'Bahamian',
    value: 'Bahamian',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '巴林',
    labelEn: 'Bahraini',
    value: 'Bahraini',
    hasChild: false,
    children: [],
    alpha2: 'BH',
    alpha3: 'BHR'
  },
  {
    label: '孟加拉国',
    labelEn: 'Bengali',
    value: 'Bengali',
    hasChild: false,
    children: [],
    alpha2: 'BD',
    alpha3: 'BGD'
  },
  {
    label: '巴巴多斯',
    labelEn: 'Barbadian',
    value: 'Barbadian',
    hasChild: false,
    children: [],
    alpha2: 'BB',
    alpha3: 'BRB'
  },
  {
    label: '白俄罗斯',
    labelEn: 'Belarusian',
    value: 'Belarusian',
    hasChild: false,
    children: [],
    alpha2: 'BY',
    alpha3: 'BLR'
  },
  {
    label: '比利时',
    labelEn: 'Belgian',
    value: 'Belgian',
    hasChild: false,
    children: [],
    alpha2: 'BE',
    alpha3: 'BEL'
  },
  {
    label: '伯利兹',
    labelEn: 'Belizean',
    value: 'Belizean',
    hasChild: false,
    children: [],
    alpha2: 'BZ',
    alpha3: 'BLZ'
  },
  {
    label: '贝宁',
    labelEn: 'Beninese, Beninois',
    value: 'Beninese, Beninois',
    hasChild: false,
    children: [],
    alpha2: 'BJ',
    alpha3: 'BEN'
  },
  {
    label: '不丹',
    labelEn: 'Bhutanese',
    value: 'Bhutanese',
    hasChild: false,
    children: [],
    alpha2: 'BT',
    alpha3: 'BTN'
  },
  {
    label: '玻利维亚',
    labelEn: 'Bolivian',
    value: 'Bolivian',
    hasChild: false,
    children: [],
    alpha2: 'BO',
    alpha3: 'BOL'
  },
  {
    label: '波斯尼亚和黑塞哥维那',
    labelEn: 'Bosnian or Herzegovinian',
    value: 'Bosnian or Herzegovinian',
    hasChild: false,
    children: [],
    alpha2: 'BA',
    alpha3: 'BIH'
  },
  {
    label: '博茨瓦纳',
    labelEn: 'Motswana, Botswanan',
    value: 'Motswana, Botswanan',
    hasChild: false,
    children: [],
    alpha2: 'BW',
    alpha3: 'BWA'
  },
  {
    label: '巴西',
    labelEn: 'Brazilian',
    value: 'Brazilian',
    hasChild: false,
    children: [],
    alpha2: 'BR',
    alpha3: 'BRA'
  },
  {
    label: '文莱',
    labelEn: 'Bruneian',
    value: 'Bruneian',
    hasChild: false,
    children: [],
    alpha2: 'BN',
    alpha3: 'BRN'
  },
  {
    label: '保加利亚',
    labelEn: 'Bulgarian',
    value: 'Bulgarian',
    hasChild: false,
    children: [],
    alpha2: 'BG',
    alpha3: 'BGR'
  },
  {
    label: '布基纳法索',
    labelEn: 'Burkinabé',
    value: 'Burkinabé',
    hasChild: false,
    children: [],
    alpha2: 'BF',
    alpha3: 'BFA'
  },
  {
    label: '缅甸',
    labelEn: 'Burmese',
    value: 'Burmese',
    hasChild: false,
    children: [],
    alpha2: 'MM',
    alpha3: 'MMR'
  },
  {
    label: '布隆迪',
    labelEn: 'Burundian',
    value: 'Burundian',
    hasChild: false,
    children: [],
    alpha2: 'BI',
    alpha3: 'BDI'
  },
  {
    label: '佛得角',
    labelEn: 'Cabo Verdean',
    value: 'Cabo Verdean',
    hasChild: false,
    children: [],
    alpha2: 'CV',
    alpha3: 'CPV'
  },
  {
    label: '柬埔寨',
    labelEn: 'Cambodian',
    value: 'Cambodian',
    hasChild: false,
    children: [],
    alpha2: 'KH',
    alpha3: 'KHM'
  },
  {
    label: '喀麦隆',
    labelEn: 'Cameroonian',
    value: 'Cameroonian',
    hasChild: false,
    children: [],
    alpha2: 'CM',
    alpha3: 'CMR'
  },
  {
    label: '加拿大',
    labelEn: 'Canadian',
    value: 'Canadian',
    hasChild: false,
    children: [],
    alpha2: 'CA',
    alpha3: 'CAN'
  },
  {
    label: '中非',
    labelEn: 'Central African',
    value: 'Central African',
    hasChild: false,
    children: [],
    alpha2: 'CF',
    alpha3: 'CAF'
  },
  {
    label: '乍得',
    labelEn: 'Chadian',
    value: 'Chadian',
    hasChild: false,
    children: [],
    alpha2: 'TD',
    alpha3: 'TCD'
  },
  {
    label: '智利',
    labelEn: 'Chilean',
    value: 'Chilean',
    hasChild: false,
    children: [],
    alpha2: 'CL',
    alpha3: 'CHL'
  },
  {
    label: '中国',
    labelEn: 'Chinese',
    value: 'Chinese',
    hasChild: false,
    children: [],
    alpha2: 'CN',
    alpha3: 'CHN'
  },
  {
    label: '哥伦比亚',
    labelEn: 'Colombian',
    value: 'Colombian',
    hasChild: false,
    children: [],
    alpha2: 'CO',
    alpha3: 'COL'
  },
  {
    label: '科摩罗',
    labelEn: 'Comoran, Comorian',
    value: 'Comoran, Comorian',
    hasChild: false,
    children: [],
    alpha2: 'KM',
    alpha3: 'COM'
  },
  {
    label: '刚果民主共和国',
    labelEn: 'D.R.Congolese',
    value: 'D.R.Congolese',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '刚果共和国',
    labelEn: 'Congolese',
    value: 'Congolese',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '哥斯达黎加',
    labelEn: 'Costa Rican',
    value: 'Costa Rican',
    hasChild: false,
    children: [],
    alpha2: 'CR',
    alpha3: 'CRI'
  },
  {
    label: '克罗地亚',
    labelEn: 'Croatian',
    value: 'Croatian',
    hasChild: false,
    children: [],
    alpha2: 'HR',
    alpha3: 'HRV'
  },
  {
    label: '古巴',
    labelEn: 'Cuban',
    value: 'Cuban',
    hasChild: false,
    children: [],
    alpha2: 'CU',
    alpha3: 'CUB'
  },
  {
    label: '塞浦路斯',
    labelEn: 'Cypriot',
    value: 'Cypriot',
    hasChild: false,
    children: [],
    alpha2: 'CY',
    alpha3: 'CYP'
  },
  {
    label: '捷克',
    labelEn: 'Czech',
    value: 'Czech',
    hasChild: false,
    children: [],
    alpha2: 'CZ',
    alpha3: 'CZE'
  },
  {
    label: '丹麦',
    labelEn: 'Danish',
    value: 'Danish',
    hasChild: false,
    children: [],
    alpha2: 'DK',
    alpha3: 'DNK'
  },
  {
    label: '吉布提',
    labelEn: 'Djiboutian',
    value: 'Djiboutian',
    hasChild: false,
    children: [],
    alpha2: 'DJ',
    alpha3: 'DJI'
  },
  {
    label: '多米尼克',
    labelEn: 'Dominican',
    value: 'Dominican',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '多米尼加共和国',
    labelEn: 'Dominican Republic',
    value: 'Dominican Republic',
    hasChild: false,
    children: [],
    alpha2: 'DO',
    alpha3: 'DOM'
  },
  {
    label: '东帝汶',
    labelEn: 'Timorese',
    value: 'Timorese',
    hasChild: false,
    children: [],
    alpha2: 'TL',
    alpha3: 'TLS'
  },
  {
    label: '厄瓜多尔',
    labelEn: 'Ecuadorian',
    value: 'Ecuadorian',
    hasChild: false,
    children: [],
    alpha2: 'EC',
    alpha3: 'ECU'
  },
  {
    label: '埃及',
    labelEn: 'Egyptian',
    value: 'Egyptian',
    hasChild: false,
    children: [],
    alpha2: 'EG',
    alpha3: 'EGY'
  },
  {
    label: '萨尔瓦多',
    labelEn: 'Salvadoran',
    value: 'Salvadoran',
    hasChild: false,
    children: [],
    alpha2: 'SV',
    alpha3: 'SLV'
  },
  {
    label: '赤道几内亚',
    labelEn: 'Equatorial Guinean, Equatoguinean',
    value: 'Equatorial Guinean, Equatoguinean',
    hasChild: false,
    children: [],
    alpha2: 'GQ',
    alpha3: 'GNQ'
  },
  {
    label: '厄立特里亚',
    labelEn: 'Eritrean',
    value: 'Eritrean',
    hasChild: false,
    children: [],
    alpha2: 'ER',
    alpha3: 'ERI'
  },
  {
    label: '爱沙尼亚',
    labelEn: 'Estonian',
    value: 'Estonian',
    hasChild: false,
    children: [],
    alpha2: 'EE',
    alpha3: 'EST'
  },
  {
    label: '埃塞俄比亚',
    labelEn: 'Ethiopian',
    value: 'Ethiopian',
    hasChild: false,
    children: [],
    alpha2: 'ET',
    alpha3: 'ETH'
  },
  {
    label: '斐济',
    labelEn: 'Fijian',
    value: 'Fijian',
    hasChild: false,
    children: [],
    alpha2: 'FJ',
    alpha3: 'FJI'
  },
  {
    label: '芬兰',
    labelEn: 'Finnish',
    value: 'Finnish',
    hasChild: false,
    children: [],
    alpha2: 'FI',
    alpha3: 'FIN'
  },
  {
    label: '法国',
    labelEn: 'French',
    value: 'French',
    hasChild: false,
    children: [],
    alpha2: 'FR',
    alpha3: 'FRA'
  },
  {
    label: '加蓬',
    labelEn: 'Gabonese',
    value: 'Gabonese',
    hasChild: false,
    children: [],
    alpha2: 'GA',
    alpha3: 'GAB'
  },
  {
    label: '冈比亚',
    labelEn: 'Gambian',
    value: 'Gambian',
    hasChild: false,
    children: [],
    alpha2: 'GM',
    alpha3: 'GMB'
  },
  {
    label: '格鲁吉亚',
    labelEn: 'Georgian',
    value: 'Georgian',
    hasChild: false,
    children: [],
    alpha2: 'GE',
    alpha3: 'GEO'
  },
  {
    label: '德国',
    labelEn: 'German',
    value: 'German',
    hasChild: false,
    children: [],
    alpha2: 'DE',
    alpha3: 'DEU'
  },
  {
    label: '加纳',
    labelEn: 'Ghanaian',
    value: 'Ghanaian',
    hasChild: false,
    children: [],
    alpha2: 'GH',
    alpha3: 'GHA'
  },
  {
    label: '直布罗陀',
    labelEn: 'Gibraltar',
    value: 'Gibraltar',
    hasChild: false,
    children: [],
    alpha2: 'GI',
    alpha3: 'GIB'
  },
  {
    label: '希腊',
    labelEn: 'Greek, Hellenic',
    value: 'Greek, Hellenic',
    hasChild: false,
    children: [],
    alpha2: 'GR',
    alpha3: 'GRC'
  },
  {
    label: '格林纳达',
    labelEn: 'Grenadian',
    value: 'Grenadian',
    hasChild: false,
    children: [],
    alpha2: 'GD',
    alpha3: 'GRD'
  },
  {
    label: '危地马拉',
    labelEn: 'Guatemalan',
    value: 'Guatemalan',
    hasChild: false,
    children: [],
    alpha2: 'GT',
    alpha3: 'GTM'
  },
  {
    label: '几内亚',
    labelEn: 'Guinean',
    value: 'Guinean',
    hasChild: false,
    children: [],
    alpha2: 'GN',
    alpha3: 'GIN'
  },
  {
    label: '几内亚比绍',
    labelEn: 'Bissau-Guinean',
    value: 'Bissau-Guinean',
    hasChild: false,
    children: [],
    alpha2: 'GW',
    alpha3: 'GNB'
  },
  {
    label: '圭亚那',
    labelEn: 'Guyanese',
    value: 'Guyanese',
    hasChild: false,
    children: [],
    alpha2: 'GY',
    alpha3: 'GUY'
  },
  {
    label: '海地',
    labelEn: 'Haitian',
    value: 'Haitian',
    hasChild: false,
    children: [],
    alpha2: 'HT',
    alpha3: 'HTI'
  },
  {
    label: '洪都拉斯 ',
    labelEn: 'Honduran',
    value: 'Honduran',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '匈牙利',
    labelEn: 'Hungarian, Magyar',
    value: 'Hungarian, Magyar',
    hasChild: false,
    children: [],
    alpha2: 'HU',
    alpha3: 'HUN'
  },
  {
    label: '冰岛',
    labelEn: 'Icelandic',
    value: 'Icelandic',
    hasChild: false,
    children: [],
    alpha2: 'IS',
    alpha3: 'ISL'
  },
  {
    label: '印度',
    labelEn: 'Indian',
    value: 'Indian',
    hasChild: false,
    children: [],
    alpha2: 'IN',
    alpha3: 'IND'
  },
  {
    label: '印度尼西亚',
    labelEn: 'Indonesian',
    value: 'Indonesian',
    hasChild: false,
    children: [],
    alpha2: 'ID',
    alpha3: 'IDN'
  },
  {
    label: '伊朗',
    labelEn: 'Iranian, Persian',
    value: 'Iranian, Persian',
    hasChild: false,
    children: [],
    alpha2: 'IR',
    alpha3: 'IRN'
  },
  {
    label: '伊拉克',
    labelEn: 'Iraqi',
    value: 'Iraqi',
    hasChild: false,
    children: [],
    alpha2: 'IQ',
    alpha3: 'IRQ'
  },
  {
    label: '爱尔兰',
    labelEn: 'Irish',
    value: 'Irish',
    hasChild: false,
    children: [],
    alpha2: 'IE',
    alpha3: 'IRL'
  },
  {
    label: '以色列',
    labelEn: 'Israeli',
    value: 'Israeli',
    hasChild: false,
    children: [],
    alpha2: 'IL',
    alpha3: 'ISR'
  },
  {
    label: '意大利',
    labelEn: 'Italian',
    value: 'Italian',
    hasChild: false,
    children: [],
    alpha2: 'IT',
    alpha3: 'ITA'
  },
  {
    label: '科特迪瓦',
    labelEn: 'Ivorian',
    value: 'Ivorian',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '牙买加',
    labelEn: 'Jamaican',
    value: 'Jamaican',
    hasChild: false,
    children: [],
    alpha2: 'JM',
    alpha3: 'JAM'
  },
  {
    label: '日本',
    labelEn: 'Japanese',
    value: 'Japanese',
    hasChild: false,
    children: [],
    alpha2: 'JP',
    alpha3: 'JPN'
  },
  {
    label: '约旦',
    labelEn: 'Jordanian',
    value: 'Jordanian',
    hasChild: false,
    children: [],
    alpha2: 'JO',
    alpha3: 'JOR'
  },
  {
    label: '哈萨克斯坦',
    labelEn: 'Kazakhstani, Kazakh',
    value: 'Kazakhstani, Kazakh',
    hasChild: false,
    children: [],
    alpha2: 'KZ',
    alpha3: 'KAZ'
  },
  {
    label: '肯尼亚',
    labelEn: 'Kenyan',
    value: 'Kenyan',
    hasChild: false,
    children: [],
    alpha2: 'KE',
    alpha3: 'KEN'
  },
  {
    label: '基里巴斯',
    labelEn: 'I-Kiribati',
    value: 'I-Kiribati',
    hasChild: false,
    children: [],
    alpha2: 'KI',
    alpha3: 'KIR'
  },
  {
    label: '朝鲜',
    labelEn: 'North Korean',
    value: 'North Korean',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '韩国',
    labelEn: 'South Korean',
    value: 'South Korean',
    hasChild: false,
    children: [],
    alpha2: 'KR',
    alpha3: 'KOR'
  },
  {
    label: '科威特',
    labelEn: 'Kuwaiti',
    value: 'Kuwaiti',
    hasChild: false,
    children: [],
    alpha2: 'KW',
    alpha3: 'KWT'
  },
  {
    label: '吉尔吉斯斯坦',
    labelEn: 'Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz',
    value: 'Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz',
    hasChild: false,
    children: [],
    alpha2: 'KG',
    alpha3: 'KGZ'
  },
  {
    label: '老挝',
    labelEn: 'Lao, Laotian',
    value: 'Lao, Laotian',
    hasChild: false,
    children: [],
    alpha2: 'LA',
    alpha3: 'LAO'
  },
  {
    label: '拉脱维亚',
    labelEn: 'Latvian, Lettish',
    value: 'Latvian, Lettish',
    hasChild: false,
    children: [],
    alpha2: 'LV',
    alpha3: 'LVA'
  },
  {
    label: '黎巴嫩',
    labelEn: 'Lebanese',
    value: 'Lebanese',
    hasChild: false,
    children: [],
    alpha2: 'LB',
    alpha3: 'LBN'
  },
  {
    label: '莱索托',
    labelEn: 'Basotho',
    value: 'Basotho',
    hasChild: false,
    children: [],
    alpha2: 'LS',
    alpha3: 'LSO'
  },
  {
    label: '利比里亚',
    labelEn: 'Liberian',
    value: 'Liberian',
    hasChild: false,
    children: [],
    alpha2: 'LR',
    alpha3: 'LBR'
  },
  {
    label: '利比亚',
    labelEn: 'Libyan',
    value: 'Libyan',
    hasChild: false,
    children: [],
    alpha2: 'LY',
    alpha3: 'LBY'
  },
  {
    label: '列支敦士登',
    labelEn: 'Liechtensteiner',
    value: 'Liechtensteiner',
    hasChild: false,
    children: [],
    alpha2: 'LI',
    alpha3: 'LIE'
  },
  {
    label: '立陶宛',
    labelEn: 'Lithuanian',
    value: 'Lithuanian',
    hasChild: false,
    children: [],
    alpha2: 'LT',
    alpha3: 'LTU'
  },
  {
    label: '卢森堡',
    labelEn: 'Luxembourg, Luxembourgish',
    value: 'Luxembourg, Luxembourgish',
    hasChild: false,
    children: [],
    alpha2: 'LU',
    alpha3: 'LUX'
  },
  {
    label: '北马其顿',
    labelEn: 'Macedonian',
    value: 'Macedonian',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '马达加斯加',
    labelEn: 'Malagasy',
    value: 'Malagasy',
    hasChild: false,
    children: [],
    alpha2: 'MG',
    alpha3: 'MDG'
  },
  {
    label: '马拉维',
    labelEn: 'Malawian',
    value: 'Malawian',
    hasChild: false,
    children: [],
    alpha2: 'MW',
    alpha3: 'MWI'
  },
  {
    label: '马来西亚',
    labelEn: 'Malaysian',
    value: 'Malaysian',
    hasChild: false,
    children: [],
    alpha2: 'MY',
    alpha3: 'MYS'
  },
  {
    label: '马尔代夫',
    labelEn: 'Maldivian',
    value: 'Maldivian',
    hasChild: false,
    children: [],
    alpha2: 'MV',
    alpha3: 'MDV'
  },
  {
    label: '马里',
    labelEn: 'Malian, Malinese',
    value: 'Malian, Malinese',
    hasChild: false,
    children: [],
    alpha2: 'ML',
    alpha3: 'MLI'
  },
  {
    label: '马耳他',
    labelEn: 'Maltese',
    value: 'Maltese',
    hasChild: false,
    children: [],
    alpha2: 'MT',
    alpha3: 'MLT'
  },
  {
    label: '马绍尔群岛',
    labelEn: 'Marshallese',
    value: 'Marshallese',
    hasChild: false,
    children: [],
    alpha2: 'MH',
    alpha3: 'MHL'
  },
  {
    label: '马提尼克岛',
    labelEn: 'Martiniquais, Martinican',
    value: 'Martiniquais, Martinican',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '毛里塔尼亚',
    labelEn: 'Mauritanian',
    value: 'Mauritanian',
    hasChild: false,
    children: [],
    alpha2: 'MR',
    alpha3: 'MRT'
  },
  {
    label: '毛里求斯',
    labelEn: 'Mauritian',
    value: 'Mauritian',
    hasChild: false,
    children: [],
    alpha2: 'MU',
    alpha3: 'MUS'
  },
  {
    label: '墨西哥',
    labelEn: 'Mexican',
    value: 'Mexican',
    hasChild: false,
    children: [],
    alpha2: 'MX',
    alpha3: 'MEX'
  },
  {
    label: '密克罗尼西亚联邦',
    labelEn: 'Micronesian',
    value: 'Micronesian',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '摩尔多瓦',
    labelEn: 'Moldovan',
    value: 'Moldovan',
    hasChild: false,
    children: [],
    alpha2: 'MD',
    alpha3: 'MDA'
  },
  {
    label: '摩纳哥',
    labelEn: 'Monégasque, Monacan',
    value: 'Monégasque, Monacan',
    hasChild: false,
    children: [],
    alpha2: 'MC',
    alpha3: 'MCO'
  },
  {
    label: '蒙古',
    labelEn: 'Mongolian',
    value: 'Mongolian',
    hasChild: false,
    children: [],
    alpha2: 'MN',
    alpha3: 'MNG'
  },
  {
    label: '黑山',
    labelEn: 'Montenegrin',
    value: 'Montenegrin',
    hasChild: false,
    children: [],
    alpha2: 'ME',
    alpha3: 'MNE'
  },
  {
    label: '摩洛哥',
    labelEn: 'Moroccan',
    value: 'Moroccan',
    hasChild: false,
    children: [],
    alpha2: 'MA',
    alpha3: 'MAR'
  },
  {
    label: '莫桑比克',
    labelEn: 'Mozambican',
    value: 'Mozambican',
    hasChild: false,
    children: [],
    alpha2: 'MZ',
    alpha3: 'MOZ'
  },
  {
    label: '纳米比亚',
    labelEn: 'Namibian',
    value: 'Namibian',
    hasChild: false,
    children: [],
    alpha2: 'NA',
    alpha3: 'NAM'
  },
  {
    label: '瑙鲁',
    labelEn: 'Nauruan',
    value: 'Nauruan',
    hasChild: false,
    children: [],
    alpha2: 'NR',
    alpha3: 'NRU'
  },
  {
    label: '尼泊尔',
    labelEn: 'Nepali, Nepalese',
    value: 'Nepali, Nepalese',
    hasChild: false,
    children: [],
    alpha2: 'NP',
    alpha3: 'NPL'
  },
  {
    label: '荷兰',
    labelEn: 'Dutch, Netherlandic',
    value: 'Dutch, Netherlandic',
    hasChild: false,
    children: [],
    alpha2: 'NL',
    alpha3: 'NLD'
  },
  {
    label: '新西兰',
    labelEn: 'New Zealand, NZ, Zelanian',
    value: 'New Zealand, NZ, Zelanian',
    hasChild: false,
    children: [],
    alpha2: 'NZ',
    alpha3: 'NZL'
  },
  {
    label: '尼加拉瓜',
    labelEn: 'Nicaraguan',
    value: 'Nicaraguan',
    hasChild: false,
    children: [],
    alpha2: 'NI',
    alpha3: 'NIC'
  },
  {
    label: '尼日尔',
    labelEn: 'Nigerien',
    value: 'Nigerien',
    hasChild: false,
    children: [],
    alpha2: 'NE',
    alpha3: 'NER'
  },
  {
    label: '尼日利亚',
    labelEn: 'Nigerian',
    value: 'Nigerian',
    hasChild: false,
    children: [],
    alpha2: 'NG',
    alpha3: 'NGA'
  },
  {
    label: '北马里亚纳群岛邦',
    labelEn: 'Northern Marianan',
    value: 'Northern Marianan',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '挪威',
    labelEn: 'Norwegian',
    value: 'Norwegian',
    hasChild: false,
    children: [],
    alpha2: 'NO',
    alpha3: 'NOR'
  },
  {
    label: '阿曼',
    labelEn: 'Omani',
    value: 'Omani',
    hasChild: false,
    children: [],
    alpha2: 'OM',
    alpha3: 'OMN'
  },
  {
    label: '巴基斯坦',
    labelEn: 'Pakistani',
    value: 'Pakistani',
    hasChild: false,
    children: [],
    alpha2: 'PK',
    alpha3: 'PAK'
  },
  {
    label: '帕劳',
    labelEn: 'Palauan',
    value: 'Palauan',
    hasChild: false,
    children: [],
    alpha2: 'PW',
    alpha3: 'PLW'
  },
  {
    label: '巴勒斯坦',
    labelEn: 'Palestinian',
    value: 'Palestinian',
    hasChild: false,
    children: [],
    alpha2: 'PS',
    alpha3: 'PSE'
  },
  {
    label: '巴拿马',
    labelEn: 'Panamanian',
    value: 'Panamanian',
    hasChild: false,
    children: [],
    alpha2: 'PA',
    alpha3: 'PAN'
  },
  {
    label: '巴布亚新几内亚',
    labelEn: 'Papua New Guinean, Papuan',
    value: 'Papua New Guinean, Papuan',
    hasChild: false,
    children: [],
    alpha2: 'PG',
    alpha3: 'PNG'
  },
  {
    label: '巴拉圭',
    labelEn: 'Paraguayan',
    value: 'Paraguayan',
    hasChild: false,
    children: [],
    alpha2: 'PY',
    alpha3: 'PRY'
  },
  {
    label: '秘鲁',
    labelEn: 'Peruvian',
    value: 'Peruvian',
    hasChild: false,
    children: [],
    alpha2: 'PE',
    alpha3: 'PER'
  },
  {
    label: '菲律宾',
    labelEn: 'Filipino, Philippine',
    value: 'Filipino, Philippine',
    hasChild: false,
    children: [],
    alpha2: 'PH',
    alpha3: 'PHL'
  },
  {
    label: '波兰',
    labelEn: 'Polish',
    value: 'Polish',
    hasChild: false,
    children: [],
    alpha2: 'PL',
    alpha3: 'POL'
  },
  {
    label: '葡萄牙',
    labelEn: 'Portuguese',
    value: 'Portuguese',
    hasChild: false,
    children: [],
    alpha2: 'PT',
    alpha3: 'PRT'
  },
  {
    label: '波多黎各',
    labelEn: 'Puerto Rican',
    value: 'Puerto Rican',
    hasChild: false,
    children: [],
    alpha2: 'PR',
    alpha3: 'PRI'
  },
  {
    label: '卡塔尔',
    labelEn: 'Qatari',
    value: 'Qatari',
    hasChild: false,
    children: [],
    alpha2: 'QA',
    alpha3: 'QAT'
  },
  {
    label: '罗马尼亚',
    labelEn: 'Romanian',
    value: 'Romanian',
    hasChild: false,
    children: [],
    alpha2: 'RO',
    alpha3: 'ROU'
  },
  {
    label: '俄罗斯',
    labelEn: 'Russian',
    value: 'Russian',
    hasChild: false,
    children: [],
    alpha2: 'RU',
    alpha3: 'RUS'
  },
  {
    label: '卢旺达',
    labelEn: 'Rwandan',
    value: 'Rwandan',
    hasChild: false,
    children: [],
    alpha2: 'RW',
    alpha3: 'RWA'
  },
  {
    label: '圣基茨和尼维斯',
    labelEn: 'Kittitian or Nevisian',
    value: 'Kittitian or Nevisian',
    hasChild: false,
    children: [],
    alpha2: 'KN',
    alpha3: 'KNA'
  },
  {
    label: '圣卢西亚',
    labelEn: 'Saint Lucian',
    value: 'Saint Lucian',
    hasChild: false,
    children: [],
    alpha2: 'LC',
    alpha3: 'LCA'
  },
  {
    label: '圣文森特和格林纳丁斯',
    labelEn: 'Saint Vincentian, Vincentian',
    value: 'Saint Vincentian, Vincentian',
    hasChild: false,
    children: [],
    alpha2: 'VC',
    alpha3: 'VCT'
  },
  {
    label: '萨摩亚',
    labelEn: 'Samoan',
    value: 'Samoan',
    hasChild: false,
    children: [],
    alpha2: 'WS',
    alpha3: 'WSM'
  },
  {
    label: '圣马力诺',
    labelEn: 'Sammarinese',
    value: 'Sammarinese',
    hasChild: false,
    children: [],
    alpha2: 'SM',
    alpha3: 'SMR'
  },
  {
    label: '圣多美和普林西比',
    labelEn: 'Sao Tome',
    value: 'Sao Tome',
    hasChild: false,
    children: [],
    alpha2: 'ST',
    alpha3: 'STP'
  },
  {
    label: '沙特阿拉伯',
    labelEn: 'Saudi, Saudi Arabian',
    value: 'Saudi, Saudi Arabian',
    hasChild: false,
    children: [],
    alpha2: 'SA',
    alpha3: 'SAU'
  },
  {
    label: '塞内加尔',
    labelEn: 'Senegalese',
    value: 'Senegalese',
    hasChild: false,
    children: [],
    alpha2: 'SN',
    alpha3: 'SEN'
  },
  {
    label: '塞尔维亚',
    labelEn: 'Serbian',
    value: 'Serbian',
    hasChild: false,
    children: [],
    alpha2: 'RS',
    alpha3: 'SRB'
  },
  {
    label: '塞舌尔',
    labelEn: 'Seychellois',
    value: 'Seychellois',
    hasChild: false,
    children: [],
    alpha2: 'SC',
    alpha3: 'SYC'
  },
  {
    label: '塞拉利昂',
    labelEn: 'Sierra Leonean',
    value: 'Sierra Leonean',
    hasChild: false,
    children: [],
    alpha2: 'SL',
    alpha3: 'SLE'
  },
  {
    label: '新加坡',
    labelEn: 'Singapore, Singaporean',
    value: 'Singapore, Singaporean',
    hasChild: false,
    children: [],
    alpha2: 'SG',
    alpha3: 'SGP'
  },
  {
    label: '斯洛伐克',
    labelEn: 'Slovak',
    value: 'Slovak',
    hasChild: false,
    children: [],
    alpha2: 'SK',
    alpha3: 'SVK'
  },
  {
    label: '斯洛文尼亚',
    labelEn: 'Slovenian, Slovene',
    value: 'Slovenian, Slovene',
    hasChild: false,
    children: [],
    alpha2: 'SI',
    alpha3: 'SVN'
  },
  {
    label: '所罗门群岛',
    labelEn: 'Solomon Island',
    value: 'Solomon Island',
    hasChild: false,
    children: [],
    alpha2: 'SB',
    alpha3: 'SLB'
  },
  {
    label: '索马里',
    labelEn: 'Somali',
    value: 'Somali',
    hasChild: false,
    children: [],
    alpha2: 'SO',
    alpha3: 'SOM'
  },
  {
    label: '南非',
    labelEn: 'South African',
    value: 'South African',
    hasChild: false,
    children: [],
    alpha2: 'ZA',
    alpha3: 'ZAF'
  },
  {
    label: '南苏丹',
    labelEn: 'South Sudanese',
    value: 'South Sudanese',
    hasChild: false,
    children: [],
    alpha2: 'SS',
    alpha3: 'SSD'
  },
  {
    label: '西班牙',
    labelEn: 'Spanish',
    value: 'Spanish',
    hasChild: false,
    children: [],
    alpha2: 'ES',
    alpha3: 'ESP'
  },
  {
    label: '斯里兰卡',
    labelEn: 'Sri Lankan',
    value: 'Sri Lankan',
    hasChild: false,
    children: [],
    alpha2: 'LK',
    alpha3: 'LKA'
  },
  {
    label: '苏丹',
    labelEn: 'Sudanese',
    value: 'Sudanese',
    hasChild: false,
    children: [],
    alpha2: 'SD',
    alpha3: 'SDN'
  },
  {
    label: '苏里南',
    labelEn: 'Surinamese',
    value: 'Surinamese',
    hasChild: false,
    children: [],
    alpha2: 'SR',
    alpha3: 'SUR'
  },
  {
    label: '斯威士兰',
    labelEn: 'Swazi',
    value: 'Swazi',
    hasChild: false,
    children: [],
    alpha2: 'SZ',
    alpha3: 'SWZ'
  },
  {
    label: '瑞典',
    labelEn: 'Swedish',
    value: 'Swedish',
    hasChild: false,
    children: [],
    alpha2: 'SE',
    alpha3: 'SWE'
  },
  {
    label: '瑞士',
    labelEn: 'Swiss',
    value: 'Swiss',
    hasChild: false,
    children: [],
    alpha2: 'CH',
    alpha3: 'CHE'
  },
  {
    label: '叙利亚',
    labelEn: 'Syrian',
    value: 'Syrian',
    hasChild: false,
    children: [],
    alpha2: 'SY',
    alpha3: 'SYR'
  },
  {
    label: '塔吉克斯坦',
    labelEn: 'Tajikistani',
    value: 'Tajikistani',
    hasChild: false,
    children: [],
    alpha2: 'TJ',
    alpha3: 'TJK'
  },
  {
    label: '坦桑尼亚',
    labelEn: 'Tanzanian',
    value: 'Tanzanian',
    hasChild: false,
    children: [],
    alpha2: 'TZ',
    alpha3: 'TZA'
  },
  {
    label: '泰国',
    labelEn: 'Thai',
    value: 'Thai',
    hasChild: false,
    children: [],
    alpha2: 'TH',
    alpha3: 'THA'
  },
  {
    label: '多哥',
    labelEn: 'Togolese',
    value: 'Togolese',
    hasChild: false,
    children: [],
    alpha2: 'TG',
    alpha3: 'TGO'
  },
  {
    label: '托克劳群岛',
    labelEn: 'Tokelauan',
    value: 'Tokelauan',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '汤加',
    labelEn: 'Tongan',
    value: 'Tongan',
    hasChild: false,
    children: [],
    alpha2: 'TO',
    alpha3: 'TON'
  },
  {
    label: '特立尼达和多巴哥',
    labelEn: 'Trinidadian or Tobagonian',
    value: 'Trinidadian or Tobagonian',
    hasChild: false,
    children: [],
    alpha2: 'TT',
    alpha3: 'TTO'
  },
  {
    label: '突尼斯',
    labelEn: 'Tunisian',
    value: 'Tunisian',
    hasChild: false,
    children: [],
    alpha2: 'TN',
    alpha3: 'TUN'
  },
  {
    label: '土耳其',
    labelEn: 'Turkish',
    value: 'Turkish',
    hasChild: false,
    children: [],
    alpha2: 'TR',
    alpha3: 'TUR'
  },
  {
    label: '土库曼斯坦',
    labelEn: 'Turkmen',
    value: 'Turkmen',
    hasChild: false,
    children: [],
    alpha2: 'TM',
    alpha3: 'TKM'
  },
  {
    label: '图瓦卢',
    labelEn: 'Tuvaluan',
    value: 'Tuvaluan',
    hasChild: false,
    children: [],
    alpha2: 'TV',
    alpha3: 'TUV'
  },
  {
    label: '乌干达',
    labelEn: 'Ugandan',
    value: 'Ugandan',
    hasChild: false,
    children: [],
    alpha2: 'UG',
    alpha3: 'UGA'
  },
  {
    label: '乌克兰',
    labelEn: 'Ukrainian',
    value: 'Ukrainian',
    hasChild: false,
    children: [],
    alpha2: 'UA',
    alpha3: 'UKR'
  },
  {
    label: '阿拉伯联合酋长国',
    labelEn: 'Emirati, Emirian, Emiri',
    value: 'Emirati, Emirian, Emiri',
    hasChild: false,
    children: [],
    alpha2: '',
    alpha3: ''
  },
  {
    label: '英国',
    labelEn: 'UK, British',
    value: 'UK, British',
    hasChild: false,
    children: [],
    alpha2: 'GB',
    alpha3: 'GBR'
  },
  {
    label: '美国',
    labelEn: 'United States, U.S., American',
    value: 'United States, U.S., American',
    hasChild: false,
    children: [],
    alpha2: 'US',
    alpha3: 'USA'
  },
  {
    label: '乌拉圭',
    labelEn: 'Uruguayan',
    value: 'Uruguayan',
    hasChild: false,
    children: [],
    alpha2: 'UY',
    alpha3: 'URY'
  },
  {
    label: '乌兹别克斯坦',
    labelEn: 'Uzbekistani, Uzbek',
    value: 'Uzbekistani, Uzbek',
    hasChild: false,
    children: [],
    alpha2: 'UZ',
    alpha3: 'UZB'
  },
  {
    label: '瓦努阿图',
    labelEn: 'Ni-Vanuatu, Vanuatuan',
    value: 'Ni-Vanuatu, Vanuatuan',
    hasChild: false,
    children: [],
    alpha2: 'VU',
    alpha3: 'VUT'
  },
  {
    label: '梵蒂冈',
    labelEn: 'Vatican',
    value: 'Vatican',
    hasChild: false,
    children: [],
    alpha2: 'VA',
    alpha3: 'VAT'
  },
  {
    label: '委内瑞拉',
    labelEn: 'Venezuelan',
    value: 'Venezuelan',
    hasChild: false,
    children: [],
    alpha2: 'VE',
    alpha3: 'VEN'
  },
  {
    label: '越南',
    labelEn: 'Vietnamese',
    value: 'Vietnamese',
    hasChild: false,
    children: [],
    alpha2: 'VN',
    alpha3: 'VNM'
  },
  {
    label: '也门',
    labelEn: 'Yemeni',
    value: 'Yemeni',
    hasChild: false,
    children: [],
    alpha2: 'YE',
    alpha3: 'YEM'
  },
  {
    label: '赞比亚',
    labelEn: 'Zambian',
    value: 'Zambian',
    hasChild: false,
    children: [],
    alpha2: 'ZM',
    alpha3: 'ZMB'
  },
  {
    label: '津巴布韦',
    labelEn: 'Zimbabwean',
    value: 'Zimbabwean',
    hasChild: false,
    children: [],
    alpha2: 'ZW',
    alpha3: 'ZWE'
  }
]
